import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Product, ProductService } from '../product.service';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.css']
})

export class ProductListComponent implements OnInit {
  dataSource: MatTableDataSource<Product> = new MatTableDataSource<Product>();
  // paginator!: MatPaginator;
  sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  constructor(private productService: ProductService, private router: Router, public dialog: MatDialog) { }

  ngOnInit(): void {
    this.getProduct();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  getProduct() {
    this.productService.getAll().subscribe(
      (data: Product[]) => {
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      },
      (error) => {
        console.log("ดึงข้อมูลไม่สำเร็จ");
      }
    )
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  editProduct(barcode: number) {
    this.router.navigate(['/edit-product', barcode]);
  }
  openDialog(product: Product) {
    this.dialog.open(ReceiveDialog, { data: product });
  }
  displayedColumns: string[] = ['name', 'front_store_price', 'wholesale_price', 'unit_type', 'option'];
}
@Component({
  selector: 'receive-dialog',
  templateUrl: 'receive-product.html'
})

export class ReceiveDialog implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public product: Product, private productService: ProductService, public dialog: MatDialog) { }

  ngOnInit() { }
  receiveForm = new FormGroup({
    id: new FormControl(this.product.product_id),
    cost: new FormControl(this.product.cost),
    front_store_price: new FormControl(this.product.front_store_price),
    wholesale_price: new FormControl(this.product.wholesale_price),
    quantity: new FormControl(),
  })

  save() {
    this.productService.receiveProduct(this.receiveForm.value).subscribe(() => {
      this.dialog.closeAll();
    }, (error) => {
      alert('บันทึกไม่สำเร็จ')
    })
  }
}